import type { JSONContent } from "@tiptap/core";

const CELLS = new Set(["tableCell", "tableHeader"]);

// Markdown keeps a column width in the header row only; prosemirror-tables copies it to every
// cell of the column after a row is inserted, which would mark each row as changed.
const withoutBodyColumnWidths = (table: JSONContent): JSONContent => ({
	...table,
	content: table.content?.map((row, index) =>
		index === 0
			? row
			: {
					...row,
					content: row.content?.map((cell) =>
						CELLS.has(cell.type ?? "") && cell.attrs
							? { ...cell, attrs: { ...cell.attrs, colwidth: null } }
							: cell,
					),
				},
	),
});

const normalizeForDiff = (content: JSONContent): JSONContent => {
	if (content.type === "table") return withoutBodyColumnWidths(content);
	if (!content.content) return content;
	return { ...content, content: content.content.map(normalizeForDiff) };
};

export default normalizeForDiff;
